const scrollbar = (container, scroll_y = '.external-scroll_y') => {

    const $container = $(container);
    const $scroll_y = $(scroll_y);

    $container.scrollbar({
        "autoScrollSize": false,
        "scrolly": $scroll_y
    });

};

export default scrollbar;